import React from "react";
import { Row, Col } from "react-bootstrap";

import useFocus from "hooks/useFocus";

import "./style.scss";

export const SearchResultsBody = ({ md, item, labels, parentWidget, descOpen, setDescOpen, parentId }) => {
  const needCustomFocus = labels.is_calculator && !Utils.isMobile() && parentId == "searchResult0";
  const { customFocusOnShiftTab } = useFocus(needCustomFocus);
  const handleClick = () => {
    setDescOpen(prevState => !prevState);
  }

  return (
    <Col sm={12} md={md} className={"sm-padding-left-0 md-padding-left-15px"}>
      <div className="search-results-body" tabIndex="0">
        <Row>
          <Col className="title" md={12} >
            <a id={`title_${parentId}`} 
            aria-label={item.title}  
            href={`/node/${item.nid}`} 
            target="_blank"
            onKeyDown={ needCustomFocus ? (event) => customFocusOnShiftTab(event, "sortBtn") : undefined }>
              {item.title} { item.track ? `- ${item.track}` : "" }
            </a>
          </Col>
          {Utils.isMobile() && parentWidget == "FavoriteProgramGrid" && (
            <div role="button" className="open-desc-btn" onClick={handleClick}>{descOpen ? labels.close : labels.read_more}</div>
          )}
          {( !Utils.isMobile() || ( parentWidget == "FavoriteProgramGrid" && descOpen ) ) && (
            <Col md={12} className="body" tabIndex="0">
              {Utils.removeTags(item.field_short_description)}
            </Col>
          )}
          {( !Utils.isMobile() || !parentWidget == "FavoriteProgramGrid" || descOpen ) && (
            <Row xs={2} className="tags">
              {item.field_degree_type && (
                <Col sm={"auto"} md={"auto"} className="tag">
                  {item.field_degree_type}
                </Col>
              )}
              {item.field_studying_year_number && (
                <Col sm={"auto"} md={"auto"} className="tag">
                  {item.field_studying_year_number} {labels.years_of_study}
                </Col>
              )}
              {item.field_learning_aspect && (
                <Col sm={"auto"} md={"auto"} className="tag">
                  {item.field_learning_aspect}
                </Col>
              )}
              <Col sm={"auto"} md={"auto"} className="tag">
                {item.field_external_department_id}
              </Col>
            </Row>
          )}
        </Row>
      </div>
    </Col>
  );
};
